module.exports = __webpack_public_path__ + "img/tab03.44f5bc24.jpg";